(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 1007px)';

  function createLightbox() {
    var existing = document.getElementById('ss-product-lightbox');
    if (existing) return existing;

    var lightbox = document.createElement('div');
    lightbox.id = 'ss-product-lightbox';
    lightbox.className = 'SSProductLightbox';
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.innerHTML = [
      '<button type="button" class="SSProductLightbox__Close" aria-label="Bildansicht schließen">×</button>',
      '<div class="SSProductLightbox__Track" tabindex="0"></div>'
    ].join('');

    document.body.appendChild(lightbox);

    lightbox.querySelector('.SSProductLightbox__Close').addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) closeLightbox();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && lightbox.classList.contains('is-open')) {
        closeLightbox();
      }
    });

    return lightbox;
  }

  function getGalleryImages() {
    return Array.prototype.slice.call(document.querySelectorAll('.Product__Slideshow .Product__SlideItem--image img'));
  }

  function getCurrentIndex() {
    var slider = document.querySelector('.Product__Slideshow');
    if (!slider) return 0;
    var slides = Array.prototype.slice.call(slider.querySelectorAll('.Product__SlideItem'));
    if (!slides.length) return 0;

    var width = slider.clientWidth || 1;
    var index = Math.round(slider.scrollLeft / width);
    return Math.max(0, Math.min(index, slides.length - 1));
  }

  function openLightbox(index) {
    if (!window.matchMedia(MOBILE_QUERY).matches) return;

    var images = getGalleryImages();
    if (!images.length) return;

    var lightbox = createLightbox();
    var track = lightbox.querySelector('.SSProductLightbox__Track');
    track.innerHTML = '';

    images.forEach(function (source) {
      var slide = document.createElement('div');
      slide.className = 'SSProductLightbox__Slide';

      var img = document.createElement('img');
      img.alt = source.alt || '';
      img.src = source.getAttribute('data-original-src') || source.currentSrc || source.src;
      img.decoding = 'async';

      slide.appendChild(img);
      track.appendChild(slide);
    });

    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ss-lightbox-open');
    document.body.classList.add('ss-lightbox-open');

    window.requestAnimationFrame(function () {
      var target = track.children[index] || track.children[0];
      if (target) target.scrollIntoView({ behavior: 'auto', inline: 'start', block: 'nearest' });
      track.focus({ preventScroll: true });
    });
  }

  function closeLightbox() {
    var lightbox = document.getElementById('ss-product-lightbox');
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ss-lightbox-open');
    document.body.classList.remove('ss-lightbox-open');
  }

  document.addEventListener('click', function (event) {
    if (!window.matchMedia(MOBILE_QUERY).matches) return;

    var zoomButton = event.target.closest && event.target.closest('[data-action="open-product-zoom"]');
    if (zoomButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openLightbox(getCurrentIndex());
      return;
    }

    var image = event.target.closest && event.target.closest('.Product__Slideshow .Product__SlideItem--image img');
    if (image) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var slide = image.closest('.Product__SlideItem');
      var slides = Array.prototype.slice.call(document.querySelectorAll('.Product__Slideshow .Product__SlideItem--image'));
      openLightbox(Math.max(0, slides.indexOf(slide)));
    }
  }, true);
}());
